export enum DigitalAssetType {
  Background = "background",
  Poster = "poster",
  Video = "video",
}
